
<div class="modal-body">
  <div class="form-group" *ngIf="token.activity.length &gt; 0">
    <label translate>Activity log</label>
    <div class="list-group">
      <div class="list-group-item d-flex" *ngFor="let activity of token.activity">
        <div class="selectable mr-auto" translate>Accessed from {{activity.ip}}</div>
        <div>{{activity.date|date:'medium'}}</div>
      </div>
    </div>
  </div>
</div>
<div class="modal-footer">
  <button class="btn btn-outline-secondary" (click)="modalInstance.close()" data-test-qa="close" translate>Close</button>
</div>